export default __webpack_public_path__ + "static/step-3-0aa31c5c334b0236db2037530a24e038.png";